// Controllo della versione del frontend (02/10/2026, docs/02). La compilazione scrive versione.json accanto
// a index.html e mette la stessa versione nel codice (__VERSIONE_APP__, vite.config.ts). Ogni tanto l'app
// rilegge versione.json: se è cambiata, il layout mostra "È disponibile una versione nuova" e l'utente
// sceglie quando aggiornare, così una registrazione a metà non si perde mai.
// È un file statico, non un'API del CRM: per questo non passa da api/client.ts (regola 5).
import { ref } from 'vue';

declare const __VERSIONE_APP__: string;
export const versioneApp = __VERSIONE_APP__;
export const nuovaVersione = ref(false);

const INTERVALLO_MS = 5 * 60_000; // non più di un controllo ogni 5 minuti
let ultimoControllo = 0;

async function controlla(): Promise<void> {
  if (import.meta.env.DEV || nuovaVersione.value) return;
  if (Date.now() - ultimoControllo < INTERVALLO_MS) return;
  ultimoControllo = Date.now();
  try {
    const r = await fetch('/versione.json', { cache: 'no-store' });
    if (!r.ok) return;
    const { versione } = (await r.json()) as { versione?: string };
    if (versione && versione !== versioneApp) nuovaVersione.value = true;
  } catch {
    // senza rete o file mancante: si riprova al prossimo giro
  }
}

/** Avvia i controlli: quando l'app torna in primo piano, a ogni cambio di pagina e ogni 5 minuti. */
export function avviaControlloVersione(dopoOgniPagina: (f: () => void) => void): void {
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void controlla(); });
  dopoOgniPagina(() => void controlla());
  setInterval(() => void controlla(), INTERVALLO_MS);
}

export function aggiorna(): void {
  window.location.reload();
}
